import { Icon as IconifyIcon } from '@iconify/react'

export default function Icon({ icon }) {
  const formatted = icon.includes(':') ? icon : `fa6-regular:${icon}`

  return <IconifyIcon icon={formatted} />
}